module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "u-m3"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createPaymentMethod.apply(null, arguments)
      }
    }
  }, [_c('div', {
    attrs: {
      "id": _vm.paymentElementMountNodeId
    }
  }), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "u-warning"
  }, [_c('i', {
    staticClass: "material-icons md-text",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("warning")]), _vm._v(" " + _vm._s(_vm.errorMessage) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.authorizationSetup && _vm.authorizationSetup.captureAuthorization) ? _c('div', {
    staticClass: "authorization-checkbox u-mt2"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.authorizationConfirmed),
      callback: function($$v) {
        _vm.authorizationConfirmed = $$v
      },
      expression: "authorizationConfirmed"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.authorizationSetup.disclosureFirstParty)
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u-mt3"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "nativeType": "submit",
      "disabled": _vm.paymentButtonDisabled
    }
  }, [_vm._v(_vm._s(_vm.t('payments.save_payment_method')))])], 1)])])
},staticRenderFns: []}